import ErrorImage from "./ErrorImage";

export default function ErrorDisplay({message, code}) {
    return (
        <div className='d-flex justify-content-center loading-errors-div'>
            <ErrorImage code={code}/>
            <p>{message}<br/>Status {code}</p>
        </div>
    )
}